import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import TheMembersTable from "../../../components/apps/themembers/TheMembersTable";
import { useNavigate } from "react-router";

export default function TheMembers() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - TheMembers"
                description="TheMembers"
            />
            <PageBreadcrumb
                pageTitle="TheMembers"
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">

                <div className="col-span-12 space-y-6">
                    <TheMembersTable />
                </div>
            </div>
        </>
    );
}